import { CUE_LABELS, soundBoard, type Cue } from '../lib/sound';
import { Panel } from './Bits';
import { MusicVolumeControl, VolumeControl } from './VolumeControl';

const CUES = Object.keys(CUE_LABELS) as Cue[];

/**
 * Klangpult des Spielleiters. Ansagen und Musik laufen auf diesem Rechner – so stellst du deine
 * Lautstärke selbst ein, und OBS nimmt den Ton dieses Rechners auf. Die Spieler regeln ihren Ton
 * in ihrer eigenen Ansicht.
 */
export function SoundBoardPanel() {
  return (
    <Panel title="Klang">
      <VolumeControl />
      <MusicVolumeControl />
      <div className="grid-two">
        {CUES.map((cue) => (
          <button key={cue} type="button" className="tiny" onClick={() => void soundBoard.play(cue)}>
            {CUE_LABELS[cue]}
          </button>
        ))}
      </div>
      <p className="tiny muted" style={{ marginTop: '0.7rem' }}>
        Eigene Aufnahmen kommen als <code>/sounds/NIGHT.mp3</code> usw. in den Ordner <code>public/sounds</code>.
      </p>
    </Panel>
  );
}
